import React from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import Button from 'components/elements/buttons/Button';
import CommonModal from 'components/elements/modals/CommonModal';
import img from 'components/dashboard/earn-content/EarnSwitcher/ReviewModal/images/ic_paper-airplane.svg';

import './ReviewModal.css';

const ReviewModal = ({
  open,
  onClose,
}) => (
  <CommonModal
    className="earn-switcher-review-modal__component"
    open={open}
    onClose={onClose}
  >
    <div className="wrapper">
      <div className="text-content">
        <img src={img} alt="" />
        <b>
          {i18n.t("Thank you! We will review your account")}<br />
          {i18n.t("and automatically turn on advertising if it meets all")}<br />
          {i18n.t("of our advertising guidelines.")}
        </b>
      </div>
      <div className="buttons-block">
        <Button
          className="modal-button confirm"
          onClick={onClose}
        >
          {i18n.t("Ok, sounds good!")}
        </Button>
      </div>
    </div>
  </CommonModal>
);

ReviewModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
ReviewModal.defaultProps = {
  open: false,
  onClose: null,
};

export default ReviewModal;
